import React from "react";
import { t } from "../../../components/CustomComponent.js";

/* ============================================================================
 * PartnerField — กรอบของช่องกรอก 1 ช่องในใบสมัครพาร์ตเนอร์
 *
 * รวม 3 อย่างที่ทุกช่องต้องมีไว้ที่เดียว : ป้ายชื่อ + เครื่องหมายบังคับกรอก +
 * ข้อความผิดพลาดใต้ช่อง จะได้ไม่ต้องเขียนซ้ำในทุกขั้นตอน และรูปแบบตรงกันหมด
 *
 * ใช้ <label> ครอบทั้งช่องเหมือนฟอร์มลงทะเบียนสนใจทรัพย์ (PropertyLead) เพื่อให้
 * กดที่ป้ายชื่อแล้วโฟกัสเข้าช่องได้ — ยกเว้นกลุ่มปุ่ม/ชิปที่ไม่ใช่ input เดี่ยว
 * ให้ส่ง as="div" มาแทน ไม่งั้นกดปุ่มลูกจะไปโฟกัสตัวแรกของกลุ่มเสมอ
 * ========================================================================== */
export default function PartnerField({ label, required, optional, hint, error, full, as: Tag = "label", children }) {
  return (
    <Tag className={`hm-pt-field ${full ? "hm-pt-field--full" : ""} ${error ? "is-error" : ""}`}>
      <span className="hm-pt-field__label">
        {label}
        {required && <i aria-hidden="true">*</i>}
        {optional && <em>({t("partner_optional")})</em>}
      </span>

      {children}

      {/* ข้อความช่วยเหลือหายไปเมื่อมี error เพื่อไม่ให้ใต้ช่องมีสองบรรทัดแข่งกัน */}
      {error ? <span className="hm-pt-field__error">{t(error)}</span> : !!hint && <span className="hm-pt-field__hint">{hint}</span>}
    </Tag>
  );
}
